module.exports = __webpack_public_path__ + "static/img/6489_phase_function_Paper_PointsHejduk_Prediction.07d9607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6489_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Z/zh
// module chunks = 0